export default "\n      <router-outlet></router-outlet>\n     \n\n\n  \n\n";